export default {
    MAP_LOAD: 'tomtom.map.load'
};



// WEBPACK FOOTER //
// ./map/utils/events/customEvents.js